import { toast as hotToast, type ToastOptions } from 'react-hot-toast';

/**
 * A central toast utility that wraps react-hot-toast.
 * This ensures consistency and allows for global custom configuration.
 */
export const toast = {
  success: (message: string, options?: ToastOptions) => hotToast.success(message, options),
  error: (message: string, options?: ToastOptions) => hotToast.error(message, options),
  loading: (message: string, options?: ToastOptions) => hotToast.loading(message, options),
  dismiss: (id?: string) => hotToast.dismiss(id),
  // Info and warn aren't built-in to react-hot-toast, so we'll use a generic toast for them
  info: (message: string, options?: ToastOptions) => hotToast(message, { ...options, icon: 'ℹ️' }),
  warn: (message: string, options?: ToastOptions) => hotToast(message, { ...options, icon: '⚠️' }),
  // Allow direct access to the library's toast function if needed
  custom: hotToast,
};
